export default "__VITE_ASSET__fceb0e07__"